import { getConfig } from '@/config';
export const formatTag = (data) => {
    const config = getConfig();
    return Object.assign(Object.assign({}, data), { merchandiserId: config.customer });
};
export default formatTag;
